import { render, staticRenderFns } from "./people.vue?vue&type=template&id=45b86bf7&"
import script from "./people.ts?vue&type=script&lang=js&"
export * from "./people.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports